import gql from 'graphql-tag';

export const UPDATE_LOOK_CONDITION_FILTER = gql`
  mutation updateLookConditionFilter($filter: ConditionFilterInput!, $orderBy: [String]) {
    updateLookConditionFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
